import Face_31 from '../../assets/emoji/31.gif';
import Face_32 from '../../assets/emoji/32.gif';

export const emojiMap: { [code: string]: string } = {
  '31': Face_31,
  '32': Face_32,
};
